import { createSlice } from '@reduxjs/toolkit';
import { initStateGetApplicationList, reducerGetApplicationList } from '../actions/applications/getApplicationList';
import { initStateChangeStatusApplication, reducerChangeStatusApplication } from '../actions/applications/changeApplicationStatus';
import { initStateChangeApplicationStatusList, reducerChangeApplicationStatusList } from '../actions/applications/changeApplicationStatusList';
import { initStateDeleteApplicationList, reducerDeleteApplicationList } from '../actions/applications/deleteApplicationList';
import { initStateStatsApplications, reducerStatsApplications } from '../actions/applications/statsApplications';

export const initialState = {
  ...initStateGetApplicationList,
  ...initStateChangeStatusApplication,
  ...initStateChangeApplicationStatusList,
  ...initStateDeleteApplicationList,
  ...initStateStatsApplications,
};

export const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    resetGetApplicationList(state, action) {
      state.getApplicationList = initStateGetApplicationList.getApplicationList;
    },
    resetChangeStatusApplication(state, action) {
      state.changeStatusApplication = initStateChangeStatusApplication.changeStatusApplication;
    },
    resetChangeApplicationStatusList(state, action) {
      state.changeApplicationStatusList = initStateChangeApplicationStatusList.changeApplicationStatusList;
    },
    resetDeleteApplicationList(state, action) {
      state.deleteApplicationList = initStateDeleteApplicationList.deleteApplicationList;
    },
    resetStatsApplications(state, action) {
      state.statsApplications = initStateStatsApplications.statsApplications;
    },
  },
  extraReducers: {
    ...reducerGetApplicationList,
    ...reducerChangeStatusApplication,
    ...reducerChangeApplicationStatusList,
    ...reducerDeleteApplicationList,
    ...reducerStatsApplications,
  },
});
export const { resetStatsApplications, resetDeleteApplicationList, resetChangeApplicationStatusList, resetChangeStatusApplication, resetGetApplicationList } = applicationSlice.actions;
export const applicationReducer = applicationSlice.reducer;
